(() => {
  if (window.__OHD_PRODUCT_ACTIONS_LOADED__) return;
  window.__OHD_PRODUCT_ACTIONS_LOADED__ = true;

  const STORAGE_KEY = 'ohdWishlist';

  const readWishlist = () => {
    try {
      const value = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(value)
        ? value
        : [];
    } catch (error) {
      return [];
    }
  };

  const updateHeaderCount = (
    items = readWishlist()
  ) => {
    const count = items.length;

    document
      .querySelectorAll(
        '[data-ohd-wishlist-count]'
      )
      .forEach((bubble) => {
        bubble.textContent =
          count > 99
            ? '99+'
            : String(count);

        if (count > 0) {
          bubble.hidden = false;
        } else {
          bubble.hidden = true;
        }
      });
  };

  const isSaved = (
    items,
    productId
  ) =>
    items.some(
      (item) =>
        String(item.id) ===
        String(productId)
    );

  const updateWishlistButton = (
    button,
    saved
  ) => {
    const label =
      button.querySelector(
        '[data-ohd-wishlist-label]'
      );

    const title =
      button.dataset.productTitle ||
      'este producto';

    button.setAttribute(
      'aria-pressed',
      saved ? 'true' : 'false'
    );

    button.setAttribute(
      'aria-label',
      saved
        ? `Quitar ${title} de favoritos`
        : `Agregar ${title} a favoritos`
    );

    button.setAttribute(
      'title',
      saved
        ? 'Quitar de favoritos'
        : 'Agregar a favoritos'
    );

    if (label) {
      label.textContent =
        saved
          ? 'Guardado en favoritos'
          : 'Agregar a favoritos';
    }
  };

  const syncWishlistButtons = (
    items = readWishlist()
  ) => {
    document
      .querySelectorAll(
        '[data-ohd-wishlist]'
      )
      .forEach((button) => {
        updateWishlistButton(
          button,
          isSaved(
            items,
            button.dataset.productId || ''
          )
        );
      });

    updateHeaderCount(items);
  };

  const writeWishlist = (
    items
  ) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
    } catch (error) {
      return;
    }

    syncWishlistButtons(items);

    window.dispatchEvent(
      new CustomEvent(
        'ohd:wishlist:updated',
        {
          detail: { items }
        }
      )
    );
  };

  const initWishlistButtons = () => {
    syncWishlistButtons();

    document
      .querySelectorAll(
        '[data-ohd-wishlist]'
      )
      .forEach((button) => {
        if (
          button.dataset
            .ohdWishlistReady ===
          'true'
        ) {
          return;
        }

        button.dataset
          .ohdWishlistReady =
          'true';

        button.addEventListener(
          'click',
          () => {
            const productId =
              String(
                button.dataset
                  .productId || ''
              );

            if (!productId) return;

            const items =
              readWishlist();

            const index =
              items.findIndex(
                (item) =>
                  String(item.id) ===
                  productId
              );

            if (index >= 0) {
              items.splice(
                index,
                1
              );
            } else {
              items.push({
                id: productId,

                handle:
                  button.dataset
                    .productHandle ||
                  '',

                title:
                  button.dataset
                    .productTitle ||
                  '',

                url:
                  button.dataset
                    .productUrl ||
                  '',

                image:
                  button.dataset
                    .productImage ||
                  ''
              });
            }

            writeWishlist(items);
          }
        );
      });
  };

  const initCopyButtons = () => {
    document
      .querySelectorAll(
        '[data-ohd-copy-link]'
      )
      .forEach((button) => {
        if (
          button.dataset
            .ohdCopyReady ===
          'true'
        ) {
          return;
        }

        button.dataset
          .ohdCopyReady =
          'true';

        button.addEventListener(
          'click',
          async () => {
            const url =
              button.dataset
                .shareUrl ||
              window.location.href;

            const label =
              button.querySelector(
                '[data-ohd-copy-label]'
              );

            const originalLabel =
              label
                ? label.textContent
                : '';

            try {
              await navigator
                .clipboard
                .writeText(url);
            } catch (error) {
              const textarea =
                document
                  .createElement(
                    'textarea'
                  );

              textarea.value =
                url;

              textarea.setAttribute(
                'readonly',
                ''
              );

              textarea.style
                .position =
                'fixed';

              textarea.style
                .opacity =
                '0';

              document.body
                .appendChild(
                  textarea
                );

              textarea.select();

              document.execCommand(
                'copy'
              );

              textarea.remove();
            }

            if (label) {
              label.textContent =
                'Enlace copiado';

              window.setTimeout(
                () => {
                  label.textContent =
                    originalLabel ||
                    'Copiar enlace';
                },
                1800
              );
            }
          }
        );
      });
  };

  const formatMoney = (
    amount,
    currency
  ) => {
    if (
      typeof amount !==
      'number'
    ) {
      return '';
    }

    const code =
      currency || 'USD';

    const value =
      (amount / 100).toFixed(
        2
      );

    if (code === 'USD') {
      return `$${value} USD`;
    }

    return `${value} ${code}`;
  };

  const createElement = (
    tag,
    className,
    text
  ) => {
    const element =
      document.createElement(
        tag
      );

    if (className) {
      element.className =
        className;
    }

    if (
      typeof text ===
      'string'
    ) {
      element.textContent =
        text;
    }

    return element;
  };

  const createWishlistCard = (
    item,
    product,
    page
  ) => {
    const article =
      createElement(
        'article',
        'ohd-wishlist-card'
      );

    const media =
      createElement(
        'div',
        'ohd-wishlist-card__media'
      );

    const imageLink =
      createElement(
        'a',
        'ohd-wishlist-card__image-link'
      );

    imageLink.href =
      product.url ||
      item.url ||
      '#';

    imageLink.setAttribute(
      'aria-label',
      product.title ||
        item.title ||
        'Ver producto'
    );

    const image =
      document.createElement(
        'img'
      );

    image.className =
      'ohd-wishlist-card__image';

    image.loading =
      'lazy';

    image.alt =
      product.title ||
      item.title ||
      '';

    image.src =
      product.featured_image ||
      (
        product.images &&
        product.images[0]
      ) ||
      item.image ||
      '';

    if (image.src) {
      imageLink.appendChild(
        image
      );
    } else {
      imageLink.appendChild(
        createElement(
          'div',
          'ohd-wishlist-card__placeholder',
          'Sin imagen'
        )
      );
    }

    media.appendChild(
      imageLink
    );

    const remove =
      createElement(
        'button',
        'ohd-wishlist-card__remove'
      );

    remove.type =
      'button';

    remove.setAttribute(
      'aria-label',
      `Quitar ${
        product.title ||
        item.title ||
        'producto'
      } de favoritos`
    );

    remove.innerHTML = `
      <svg
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;

    remove.addEventListener(
      'click',
      () => {
        const items =
          readWishlist()
            .filter(
              (savedItem) =>
                String(
                  savedItem.id
                ) !==
                String(
                  item.id
                )
            );

        writeWishlist(items);

        renderWishlistPage(
          page
        );
      }
    );

    media.appendChild(
      remove
    );

    article.appendChild(
      media
    );

    const content =
      createElement(
        'div',
        'ohd-wishlist-card__content'
      );

    if (product.vendor) {
      content.appendChild(
        createElement(
          'span',
          'ohd-wishlist-card__vendor',
          product.vendor
        )
      );
    }

    const title =
      createElement(
        'h2',
        'ohd-wishlist-card__title'
      );

    const titleLink =
      createElement('a');

    titleLink.href =
      product.url ||
      item.url ||
      '#';

    titleLink.textContent =
      product.title ||
      item.title ||
      'Producto';

    title.appendChild(
      titleLink
    );

    content.appendChild(
      title
    );

    if (
      typeof product.price ===
      'number'
    ) {
      const price =
        createElement(
          'div',
          'ohd-wishlist-card__price'
        );

      price.appendChild(
        createElement(
          'span',
          'ohd-wishlist-card__price-current',
          formatMoney(
            product.price,
            page.dataset.currency
          )
        )
      );

      if (
        typeof product
          .compare_at_price ===
          'number' &&
        product
          .compare_at_price >
          product.price
      ) {
        price.appendChild(
          createElement(
            'span',
            'ohd-wishlist-card__price-compare',
            formatMoney(
              product
                .compare_at_price,
              page.dataset.currency
            )
          )
        );
      }

      content.appendChild(
        price
      );
    }

    const action =
      createElement(
        'a',
        'ohd-wishlist-card__action',
        'Ver producto'
      );

    action.href =
      product.url ||
      item.url ||
      '#';

    content.appendChild(
      action
    );

    article.appendChild(
      content
    );

    return article;
  };

  const getProductJson = async (
    item
  ) => {
    const url =
      item.url ||
      (
        item.handle
          ? `/products/${item.handle}`
          : ''
      );

    if (!url) {
      return null;
    }

    const cleanUrl =
      url
        .split('?')[0]
        .replace(/\/$/, '');

    try {
      const response =
        await fetch(
          `${cleanUrl}.js`,
          {
            credentials:
              'same-origin'
          }
        );

      if (
        !response.ok
      ) {
        return null;
      }

      const product =
        await response.json();

      product.url =
        cleanUrl;

      return product;
    } catch (error) {
      return null;
    }
  };

  const renderWishlistPage =
    async (page) => {
      const grid =
        page.querySelector(
          '[data-ohd-wishlist-grid]'
        );

      const empty =
        page.querySelector(
          '[data-ohd-wishlist-empty]'
        );

      const count =
        page.querySelector(
          '[data-ohd-wishlist-count]'
        );

      if (
        !grid ||
        !empty
      ) {
        return;
      }

      const items =
        readWishlist();

      if (count) {
        count.textContent =
          items.length === 1
            ? '1 producto guardado'
            : `${items.length} productos guardados`;
      }

      grid.innerHTML =
        '';

      if (
        items.length === 0
      ) {
        empty.hidden =
          false;

        grid.hidden =
          true;

        return;
      }

      empty.hidden =
        true;

      grid.hidden =
        false;

      const products =
        await Promise.all(
          items.map(
            async (item) => ({
              item,

              product:
                (
                  await getProductJson(
                    item
                  )
                ) || {
                  id:
                    item.id,

                  handle:
                    item.handle,

                  title:
                    item.title,

                  url:
                    item.url,

                  featured_image:
                    item.image,

                  price:
                    null,

                  available:
                    true
                }
            })
          )
        );

      products.forEach(
        ({
          item,
          product
        }) => {
          grid.appendChild(
            createWishlistCard(
              item,
              product,
              page
            )
          );
        }
      );
    };

  const initWishlistPage =
    () => {
      document
        .querySelectorAll(
          '[data-ohd-wishlist-page]'
        )
        .forEach(
          (page) => {
            renderWishlistPage(
              page
            );
          }
        );
    };

  const init = () => {
    initWishlistButtons();

    initCopyButtons();

    initWishlistPage();

    updateHeaderCount();
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );

  window.addEventListener(
    'ohd:wishlist:updated',
    () => {
      updateHeaderCount();

      document
        .querySelectorAll(
          '[data-ohd-wishlist-page]'
        )
        .forEach(
          (page) => {
            renderWishlistPage(
              page
            );
          }
        );
    }
  );

  window.addEventListener(
    'storage',
    (event) => {
      if (
        event.key ===
        STORAGE_KEY
      ) {
        syncWishlistButtons();

        initWishlistPage();
      }
    }
  );
})();